module.exports = __webpack_public_path__ + "img/icon_solucoesTecnologia1.cda4743f.jpg";